import { render, staticRenderFns } from "./HomerLogo.vue?vue&type=template&id=57abc062&scoped=true&"
import script from "./HomerLogo.vue?vue&type=script&lang=ts&"
export * from "./HomerLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57abc062",
  null
  
)

export default component.exports